<mat-dialog-content>
  <div class="buy-credits-container">
    <div mat-dialog-title class="title-text">{{ 'BUY_CREDITS_TITLE' | translate }}</div>

    <mat-card class="header-card">
      <div class="header-container">
        <span translate>BUY_CREDITS_AVAILABLE</span>
        <span>{{ credits }}</span>
        <span translate>BUY_CREDITS_CREDITS</span>
      </div>
    </mat-card>

    <div class="packages-grid">
      @for (pkg of creditPackages; track pkg; let i = $index) {
        <mat-card class="package-card"
          [class.selected]="selectedPackage === pkg" (click)="selectPackage(pkg)">
          <mat-card-content>
            <div class="package-info">
              <div class="credits">{{ pkg.credits }} {{ 'BUY_CREDITS_CREDITS' | translate }}</div>
              <div class="price">€{{ pkg.price.toFixed(2) }}</div>
              <div class="price-per-credit">€{{ pkg.pricePerCredit }}/{{
              'BUY_CREDITS_PER_CREDIT' | translate }}</div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>

    <div class="buy-info" translate>BUY_CREDITS_INFO</div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">{{ 'CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="!selectedPackage" (click)="addToCart()">
    {{ 'BUY_CREDITS_BUY' | translate }}
  </button>
</mat-dialog-actions>